module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_12.93231a99.png";